import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

export default function GoogleDriveCallback() {
  var code = null;
  const navigate = useNavigate();

  window.onload = async function () {
    const urlParams = new URLSearchParams(window.location.search.substring(1));
    code = urlParams.get("code");

    await saveTokenToDatabase();
  };

  async function saveTokenToDatabase() {
    var data = null;
    await axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/token?code=${code}&appId=Google drive`,{},
        {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        data = response.data;

        if (data.status === true) {
          swal({
            title: "Success!",
            text: "You have successfully authorize access",
            icon: "success",
            button: "OK",
          }).then((value) => navigate("/token-gating/google-drive"));
        } else if (data.status === false) {
          swal({
            title: data.message,
            icon: "warning",
            button: "OK",
          }).then((value) => navigate("/token-gating/google-drive"));
        }
      })
      .catch((err) => {
        swal({
          title: "Something Went Wrong!",
          icon: "error",
          button: "OK",
        }).then((value) => navigate("/token-gating/google-drive"));
      });
  }

  return (
    <div style={{ marginTop: "20%", textAlign: "center" }}>
      <CircularProgress color="secondary" />
    </div>
  );
}
